module.exports = __webpack_public_path__ + "media/images/down-daf1440deb935ae54f2ad56ae746c529.png";